import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FaFileExcelO } from 'react-icons/lib/fa';

import { withAuth } from '../../actions/';
import  { fetchAEBidPkgReport } from '../../actions/project_actions';
import { getDateValue } from '../../utils/date';
//import blackCircle from '../../images/blackCircle.png';

class AeBidTrackReport extends Component {
    // static PropTypes = {
    //     fetchAEBidPkgReport: PropTypes.func.isRequired,
    //     AEBidPkgReport: PropTypes.array.isRequired
    // }

    constructor(props, context) {
        super(props, context);
        this.handleExportToExcel = this.handleExportToExcel.bind(this);
        this.state = {
           
        };      
    }

    UNSAFE_componentWillMount() {
        this.props.fetchAEBidPkgReport();
    }
    handleExportToExcel() {
           
            let url = 'projects/AeBidExportExcel';
            let method = 'post'; 
            let responseType = 'arraybuffer';
            withAuth(
              { method, url, responseType },
              (response) => {
           
                var data = response.data;
                var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                var blob = new Blob([data], { type: contentType }); 
                var downloadUrl= window.URL.createObjectURL(blob);
               // window.open(downloadUrl,'_blank');
                  var link = document.createElement('a');
                  link.href = downloadUrl;
                  link.download='AEBid Package Report.xlsx';
                  link.click();
              },
              this.errorHandler
            )
          }
          
    render() {

        return (

            <div id="AeBidTracker" className="row-wide">

                <div className="row margin-top--2">
                    <div className="col l5 m6 s7">
                        <h4 className="margin-bottom-0">A&E BID Package Tracking Report</h4>
                    </div>
                    <div className="col l7 m6 s5">
                        <button className="btn-save btn-excel float-right margin-top-025" onClick={this.handleExportToExcel}>
                            <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                            Excel</button>
                    </div>
                </div>

                <div className="col s12 padding-bottom-175" >
                    <div className="table-scroll height-500">
                        <table className="td-table-border th-table-border table-striped">
                            <thead>
                            <tr>
                                    <th colSpan="4">Project Specification Information</th>
                                    <th colSpan="3">Constructability Status</th>
                                    <th colSpan="31">Bid Packaging Status</th>
                                    </tr>
                                <tr>
                                    <th>DDC Project ID</th>
                                    <th>Project Name</th>
                                    <th>Program Unit</th>
                                    <th>Design Project Manager</th>
                                    <th>Date Submitted</th>
                                    <th>Status</th>
                                    <th>Approved? (Y/N)</th>
                                    <th>Date Submitted (P=partial)</th>
                                    <th>Status</th>
                                    <th>Approved? (Y/N)</th>
                                    <th>Comments</th>
                                    <th>Printed specifications (PM)</th>
                                    <th>PDF specifications (PM)</th>
                                    <th>Estimate Excel(consultant)</th>
                                    <th>Addendum to General Conditions word (consultant)</th>
                                    <th>Table of Contents word (consultant)</th>
                                    <th>Bid Submission Form (PM)</th>
                                    <th>MWBE coordination(PM)</th>
                                    <th>MWBE final % (ACCO)</th>
                                    <th>CSB Sheet with PIN number</th>
                                    <th>Accessibility Form (PM)</th>
                                    <th>Approved Bid Disposition Form (PM)</th>
                                    <th>APT E‐Pin number (ACCO)</th>
                                    <th>PQL approval (PM)</th>
                                    <th>Justification (consultant)</th>
                                    <th>Bid Booklet Page (BP)</th>
                                    <th>Approved memo (PM)</th>
                                    <th>Justification (client)</th>
                                    <th>Itemized cost list(consultant)</th>
                                    <th>Approved memo (PM)</th>
                                    <th>Bid Alternates approval (PM)</th>
                                    <th>Asbestos Specifications & Drawings (BEGS)</th>
                                    <th>Unit Price Schedule(consultant)</th>
                                    <th>Commissioning Specifications(CxA)</th>
                                    <th>Geotechnical Report(consultant)</th>
                                    <th>Federal contract documents (PM)</th>
                                    <th>Feasability study for New Construction (PM)</th>
                                </tr>
                                <tr>                            
                            </tr>           
                            </thead>
                            <tbody>
                                     {
                                      this.props.AEBidPkgReport.map((aAEBidPkgReport, index) => {

                                        return <tr key={index}>
                                            <td>{aAEBidPkgReport.projectId}</td>
                                            <td>{aAEBidPkgReport.projDesc}</td>
                                            <td>{aAEBidPkgReport.progUnit}</td>
                                            <td>{aAEBidPkgReport.pmName}</td>
                                            <td>{getDateValue(aAEBidPkgReport.contstRvwSubmitdate)}</td>
                                            <td>{aAEBidPkgReport.consRvwStatus}</td>
                                            <td>{aAEBidPkgReport.approvedConsRvwStatus}</td>
                                            <td>{getDateValue(aAEBidPkgReport.bidSubmitDate)}</td>
                                            <td>{aAEBidPkgReport.bidPkgStatus}</td>
                                            <td>{aAEBidPkgReport.approvedBidPkgStatus}</td>
                                            <td>{aAEBidPkgReport.bidPkgComments}</td>
                                            <td>{aAEBidPkgReport.printSpec}</td>
                                            <td>{aAEBidPkgReport.pdfSpec}</td>
                                            <td>{aAEBidPkgReport.estimateExcel}</td>
                                            <td>{aAEBidPkgReport.adendumWord}</td>
                                            {/* <td>{aAEBidPkgReport.adendumWord === "YES" && <img src={blackCircle} />}</td> */}
                                            <td>{aAEBidPkgReport.tableContWord}</td>
                                            <td>{aAEBidPkgReport.bidSubForm}</td>
                                            <td>UnKnown</td>
                                            <td>UnKnown</td>
                                            <td>{aAEBidPkgReport.csbSsheetwPin}</td>
                                            <td>{aAEBidPkgReport.accessForm}</td>
                                            <td>UnKnown</td>
                                            <td>{aAEBidPkgReport.aptePin}</td>
                                            <td>{aAEBidPkgReport.pqlApproval}</td>
                                            <td>{aAEBidPkgReport.justificationConsult}</td>
                                            <td>{aAEBidPkgReport.bidBookletPage}</td>
                                            <td>{aAEBidPkgReport.specAppMemo}</td>
                                            <td>{aAEBidPkgReport.justificationClnt}</td>
                                            <td>{aAEBidPkgReport.itmCostList}</td>
                                            <td>{aAEBidPkgReport.itmAppMemo}</td>
                                            <td>{aAEBidPkgReport.bidAltApproval}</td>
                                            <td>{aAEBidPkgReport.asbestosSpecs}</td>
                                            <td>{aAEBidPkgReport.unitPriceSch}</td>
                                            <td>{aAEBidPkgReport.commSpecs}</td>
                                            <td>{aAEBidPkgReport.geoTechRepo}</td>
                                            <td>{aAEBidPkgReport.fedralContractDoc} </td>
                                            <td>{aAEBidPkgReport.feasabiltyStud}</td>
                                        </tr>
                                   })}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        );
    }

}

AeBidTrackReport.propTypes = {
    fetchAEBidPkgReport: PropTypes.func.isRequired,
    AEBidPkgReport: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {

        AEBidPkgReport: state.projectsStore.AEBidPkgReport,

    };
}

export default connect(mapStateToProps, { fetchAEBidPkgReport })(AeBidTrackReport);